<template>
  <div class="userinfo">
    <header-bar :name='"获奖展示"'></header-bar>
    <div class="info_wrap">
      <div class="altas_info clearfix">
        <img :src="'https://collection2021-cos.chineseplus.net/'+picData.cover" alt="" class="cover" v-if="Object.keys(picData).length">
        <div class="info_con">
          <div class="title">{{picData.title}}</div>
          <div class="author">提供者：{{picData.user_name}}</div>
          <div class="country">所在国：{{picData.cn}}</div>
        </div>
      </div>
      <div class="comment_wrap" v-if="picData.comment_one">
        <div class="comment_con">
          <img src="../img/m/comment_title.png" alt="" class="comment_title">
          <div class="comment_desc">
            <div class="comment_item">
              {{picData.comment_one}}
            </div>
            <div class="comment_item">
              {{picData.comment_two}}
            </div>
          </div>
        </div>
      </div>
      <div class="picList_con">
        <div class="picList clearfix">
          <van-swipe :initial-swipe="$route.query.index" @change="onChange">
            <van-swipe-item v-for="(v, i) in picData.photo_list" :key="i">
              <img :src="'https://collection2021-cos.chineseplus.net/'+v.photo_cover">
            </van-swipe-item>
          </van-swipe>
          <div class="desc">
            {{desc}}
          </div>
        </div>
      </div>
    </div>
    <common-footer></common-footer>

  </div>
</template>

<script>
import { Notify } from 'vant'
import {mapGetters, mapActions} from 'vuex'
import headerBar from './common/headerBar'
import commonFooter from './common/commonFooter'

export default {
  components: {
    headerBar,
    commonFooter
  },
  data () {
    return {
      picData: {},
      resultShow: false,
      desc: ''
    }
  },
  computed: {
    ...mapGetters(['getUserInfo'])
  },
  created () {
    this.getworkInfo()
  },
  methods: {
    getworkInfo () {
      this.$utils.get('/works/getInfo', {works_id: this.$route.query.id}).then(res => {
        if (res.code == 1000) {
          this.picData = res.data
          this.desc = this.picData.photo_list[0].photo_desc
        }
      })
    },
    onChange (i) {
      this.desc = this.picData.photo_list[i].photo_desc
    }
  }
}
</script>

<style lang="scss">
.van-swipe {
  padding-bottom: 1rem;
  .van-swipe__indicators {
    .van-swipe__indicator {
      background-color: #cabaf7;
    }
    .van-swipe__indicator--active {
      background-color: #9576ef;
      width: .36rem;
      border-radius: .09rem;
    }
  }
}
</style>

<style scoped lang="scss">
.userinfo {
  min-height: 100vh;
  background: #ededf6;
  .info_wrap {
    // padding: .28rem .44rem 0;
    .altas_info {
      background-color: #ffd1c7;
      padding: .3rem .35rem;
      margin-top: .3rem;
      .cover {
        width: 3.54rem;
        display: block;
        float: left;
      }
      .info_con {
        float: left;
        padding-left: .38rem;
        width: calc(100% - 3.54rem - .38rem);
        .title {
          font-size: .8rem;
          color: #282828;
          margin-bottom: .35rem;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .author {
          font-size: .48rem;
          color: #666;
        }
        .country {
          font-size: .48rem;
          color: #666;
          margin-top: .15rem;
        }
      }
    }
    .comment_wrap {
      padding: 0 .45rem;
      .comment_con {
        background-color: #ffffff;
        position: relative;
        padding: 1.4rem .5rem .6rem;
        margin-top: .8rem;
        .comment_title {
          position: absolute;
          width: 7.44rem;
          display: block;
          left: 50%;
          top: -.48rem;
          margin-left: -3.72rem;
        }
        .comment_desc {
          font-size: .35rem;
          line-height: 1.4;
          .comment_item {
            margin-bottom: .3rem;
          }
        }
      }
      
    }
    .picList_con {
      padding: 0 .45rem;
      .picList {
        padding: .25rem .35rem;
        padding-bottom: 0;
        background: #fff;
        margin-top: .3rem;
        height: calc(100vh - 7rem);
        img {
          display: block;
          // float: left;
          // width: 100%;
          height: 8rem;
          margin: auto;
        }
        .desc {
          font-size: .48rem;
          color: #666;
          line-height: 1.5;
          margin-top: .1rem;
        }
      }
    }
  }
}
</style>
